import { TimelinePost } from '@/types/post'
import { RawCurationPost } from '@/types/curation'
import { ReactNode } from 'react'

export const linkifyText = (text: string): ReactNode[] => {
  const urlRegex = /(https?:\/\/[^\s]+)/g
  const parts = text.split(urlRegex)
  
  return parts.map((part, index) => {
    if (urlRegex.test(part)) {
      return (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="text-black hover:text-gray-700 underline inline"
          onClick={(e) => e.stopPropagation()}
          title={part}
        >
          {part.length > 50 ? `${part.substring(0, 50)}...` : part}
        </a>
      )
    }
    return <span key={index}>{part}</span>
  })
}

export const convertRawCurationPostToTimelinePost = (post: RawCurationPost): TimelinePost => {
  const createdAt = post.createdAt || post.properties?.createdAt || post.metadata?.createdAt || post.created_at
  
  const contexts = post.post_context?.map((pc: any) => pc.context_id) || 
                   post.contexts || 
                   []
  
  return {
    id: post.id,
    content: post.content,
    title: post.title,
    engagement: post.engagement || 0,
    created_at: createdAt,
    createdAt: createdAt,
    updated_at: post.updated_at || createdAt,
    created_by: post.created_by,
    source_id: post.source_id,
    source: post.source,
    metadata: post.metadata,
    properties: post.properties,
    is_favorited: post.is_favorited,
    is_pinned: post.is_pinned,
    type: null,
    tags: [],
    territories: post.post_territory?.map((pt: any) => pt.territory_id) || [],
    contexts: contexts,
    topics: []
  }
}
